export const WIDGET_MARGIN = 20;
export const COLUMNS = { lg: 12, md: 8, sm: 4 };
export const WIDGET_MINS = { x: 4, y: 5 };
